import { render, staticRenderFns } from "./CommonSettings.vue?vue&type=template&id=2a90fee5&scoped=true&lang=html&"
import script from "./CommonSettings.vue?vue&type=script&lang=js&"
export * from "./CommonSettings.vue?vue&type=script&lang=js&"
import style0 from "./CommonSettings.vue?vue&type=style&index=0&id=2a90fee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90fee5",
  null
  
)

export default component.exports